import customFetch from '../../utils/customFetch';
import HttpClient from './HttpClient';

export default new HttpClient(customFetch);
